<template>
  <div class="headItem">
    <el-menu :default-active="$route.path" class="el-menu-demo" router mode="horizontal" background-color="#0273c6"
      active-text-color="#ffffef" text-color="#ffffef">
      <el-menu-item index="/homes">{{ $t('navbar.HOME') }}</el-menu-item>
      <el-submenu index="1">
        <template slot="title">{{ $t('navbar.ABOUT') }}</template>
        <el-menu-item index="/aboutus">{{ $t('navbar.ABOUTUS') }}</el-menu-item>
        <el-menu-item index="/editorial">{{ $t('navbar.EDITORIAL') }}</el-menu-item>
        <el-menu-item index="/opcItem">{{ $t('navbar.POLICY') }}</el-menu-item>
        <el-menu-item index="/newsItem">{{ $t('navbar.NEWS') }}</el-menu-item>
        <el-menu-item index="/payment">{{ $t('navbar.PAYMENT') }}</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">{{ $t('navbar.JOURNALS') }}</template>
        <!-- @click.native="chooseItem(1)" -->
        <el-menu-item index="/chineseItem?type=1">{{ $t('navbar.CJOURNALS')
        }}</el-menu-item>
        <el-menu-item index="/chineseItem?type=2">{{ $t('navbar.EJOURNALS')
        }}</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">{{ $t('navbar.BOOKS') }}</template>
        <el-menu-item index="/bookItem?type=1">{{ $t('navbar.ACABOOKS')
        }}</el-menu-item>
        <el-menu-item index="/bookItem?type=2">{{ $t('navbar.LITABOOKS')
        }}</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="3" @click="fun('/publishing')">Publish with us</el-menu-item> -->
      <el-menu-item index="/conferenceItem">{{ $t('navbar.CONFERENCE') }}</el-menu-item>
      <el-menu-item index="/contactItem">{{ $t('navbar.CONTACT') }}</el-menu-item>
    </el-menu>
  </div>
</template>
<script>

export default {
  data() {
    return {
      activeIndex: '0',
    };
  },
  watch: {
  },
  methods: {
    fun(val) {
      this.$router.push(val)
    },
    // chooseItem(type) {
    //   if (type == 2) {
    //     window.location.href = 'http://journal.omniscient.sg/' + window.location.href.split("omniscient.sg/")[1];
    //   } else {
    //     window.location.href = 'http://omniscient.sg/' + window.location.href.split("omniscient.sg/")[1];
    //   }
    // }
  },
}

</script>

<style lang="scss" scoped>
.pulish {
  font-size: 14px !important;
}

.el-menu-demo {
  display: flex;
  justify-content: center;
  border-bottom-color: #409eff
}

@media screen and (max-width: 854px) {
  .el-menu-demo {
    overflow: auto;
    height: 30px;
    line-height: 30px;
    justify-content: flex-start;
  }

  .el-submenu>>>.el-submenu__title {
    line-height: 30px;
    height: 30px;
    font-size: 12px;
    background-color: #075d9c;
  }

  .is-active>>>.el-submenu__title {
    background-color: #075d9c !important;
  }

  .el-menu--horizontal>.el-menu-item {
    line-height: 30px;
    height: 30px;
    font-size: 12px;
  }

  .el-menu--horizontal>.el-menu-item .is-active {
    line-height: 30px;
    height: 30px;
    font-size: 12px;
  }

  .el-menu-demo>.is-active {
    background: #075d9c;
    height: 30px;
  }

  .el-submenu .is-active .is-opened {
    background: #075d9c;
    height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/HeadItem.vue